module.exports = "/icon-lg-share.svg?35f200";